<div class="mb-2" style="position: relative">
	<label class="form-label fw-semibold" [for]="id"
		>{{ label }}<span class="text-danger" *ngIf="isRequired">*</span></label
	>
	<textarea
		[maxlength]="maxlength"
		class="form-control"
		aria-label="With textarea"
		[formControlName]="controlName"
		[placeholder]="placeholder"
		[id]="id"
		[ngClass]="showsTextRequired || seiraError ? 'is-invalid' : ''"></textarea>
	<div class="invalid-feedback mt-0" *ngIf="showsTextRequired || seiraError">
		{{ textRequired || seiraError }}
	</div>
</div>
